<template>
  <page-template type="rightpanel" class="notifications-pages">
    <template v-slot:toolbar>
      <tool-bar @status-change="status = $event" type="statut-selector" title="Gestion de bail" class="px-8"></tool-bar>
    </template>
    <template v-slot:central-panel-content>
      <div class="padding-x">
        <div class="pt-12">
          <h2 class="primary_">Nom et prénom locataire</h2>
          <h4 class="mb-8">Titre de la demande (Problème de paiement)</h4>
          <div class="mb-8 d-flex">
            <div class="wi-50">
              <h4>Début de bail :</h4>
            </div>
            <div class="wi-50">
              <h4>Fin de bail :</h4>
            </div>
          </div>
          <p class="mb-8">Descriptif</p>
          <div class="d-flex justify-center">
            <v-btn class="mt-4 mx-4 primary-button">Répondre</v-btn>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:right-panel-content>
      <h2 class="text-uppercase text-center">Demandes de locataire</h2>
      <panel-right-notification type="baux" class="active"></panel-right-notification>
      <panel-right-notification type="baux"></panel-right-notification>
      <panel-right-notification type="baux"></panel-right-notification>
      <panel-right-notification type="baux"></panel-right-notification>
      <panel-right-notification type="baux"></panel-right-notification>
      <panel-right-notification type="baux"></panel-right-notification>
    </template>
  </page-template>
</template>

<style lang="scss">
</style>

<script>
  import pageTemplate from '@/templates/PageTemplate.vue'
  import toolBar from '@/components/ToolBar.vue'
  import panelRightNotification from '@/components/PanelRightNotification.vue'
  import axios from 'axios'
  import { apiURL } from '@/../config'
  export default {
    name: 'Baux',
    components: { pageTemplate, toolBar, panelRightNotification },
    async created () {
      try {
        // ALL LEASES
        const leasesRes = await axios.get(`${apiURL}/data/leases/:page`)
        this.leases = leasesRes.data
        // LEASE DETAIL
        const leaseDetailRes = await axios.get(`${apiURL}/data/lease/:id`)
        this.leaseDetail = leaseDetailRes.data
      } catch (e) {
        alert('Une erreur est survenue, veuillez réessayer.')
        console.log(e)
      }
    }
  }
</script>